var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBlackAddress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.25C19 10.2214 18.7078 11.5245 18.181 12.9804C17.6599 14.4204 16.9342 15.9424 16.126 17.3304C15.3153 18.7228 14.4407 19.9473 13.634 20.8088C13.2299 21.2404 12.8652 21.5566 12.5557 21.7584C12.2325 21.9691 12.0538 22 12 22C11.9462 22 11.7675 21.9691 11.4443 21.7584C11.1348 21.5566 10.7701 21.2404 10.366 20.8088C9.55927 19.9473 8.68475 18.7228 7.87399 17.3304C7.06577 15.9424 6.34006 14.4204 5.81902 12.9804C5.2922 11.5245 5 10.2214 5 9.25C5 5.21671 8.16279 2 12 2C15.8372 2 19 5.21671 19 9.25Z",
    stroke: "#363A44",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3,
    stroke: "#363A44",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBlackAddress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_black_address.db28f407e69434cc4973c67cae39d4c6.svg";